const ShimmerKanban = () => {
    return (
      <div className="flex gap-6 h-[calc(100vh-200px)] p-4 overflow-auto">
        {/* Simulating 3 Kanban columns */}
        {[...Array(10)].map((_, colIndex) => (
          <div key={colIndex} className="w-72 bg-gray-200 p-4 rounded-lg">

            {/* Column Title */}
            {/* <div className="h-6 w-1/3 bg-gray-200 rounded-md animate-pulse mb-4"></div> */}

            {/* Cards */}
            {[...Array(1)].map((_, cardIndex) => (
              <div
                key={cardIndex}
                className="p-1 w-[260px] bg-gray-300 rounded-md animate-pulse mb-3 h-36"
              ></div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  export default ShimmerKanban;
